import Image from 'next/image';

import { ICustomIcon } from '@app-types/custom-icons';

import bigNeutral from '@assets/big/big-grey.svg';
import bigInfo from '@assets/big/big-info.svg';
import bigWhite from '@assets/big/big-white.svg';
import bigPrimary from '@assets/big/big.svg';

export function Big() {
    return <span aria-label='Big'>BiG</span>;
}

export enum BigIconVariant {
    PRIMARY = 'primary',
    INFO = 'info',
    WHITE = 'white',
    NEUTRAL = 'grey',
}
interface BigIconProps extends ICustomIcon<BigIconVariant> {
    className?: string;
}

export function BigIcon({ height = 16, variant = BigIconVariant.PRIMARY, ...props }: Readonly<BigIconProps>) {
    let image: string;
    switch (variant) {
        case BigIconVariant.INFO:
            image = bigInfo;
            break;
        case BigIconVariant.NEUTRAL:
            image = bigNeutral;
            break;
        case BigIconVariant.WHITE:
            image = bigWhite;
            break;
        case BigIconVariant.PRIMARY:
        default:
            image = bigPrimary;
            break;
    }
    return <Image height={height} blurDataURL={image} src={image} alt='Big' priority {...props} />;
}
